import React from 'react'
import { Container } from 'react-bootstrap';
import loader from './../../assets/images/Admin-Loader.gif';

export default function LoadingScreen() {
  
  return (
    <Container style={{height: '60vh'}} className="d-flex justify-content-center align-items-center">
        <img style={{height: '120px'}} src={loader} alt="loader" />
    </Container>
  )
}